import { useState, useEffect } from 'react';

/**
 * 특정 값(value)이 변경된 후 지정된 지연 시간(delay) 동안 
 * 추가적인 변경이 없을 때만 최신 값을 반환하는 커스텀 훅.
 * 주로 검색 입력창의 API 호출 횟수를 줄이기 위해 사용합니다.
 * 
 * @param {any} value - 디바운스를 적용할 값
 * @param {number} delay - 대기 시간 (밀리초, 기본값 500ms)
 * @returns {any} - 지연 처리된 값
 */
export const useDebounce = (value, delay = 500) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        // value가 바뀌거나 컴포넌트가 언마운트되면 이전 타이머를 취소
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
};
